/**
 * Minimal typed wrapper over the browser BroadcastChannel API. Used to keep the tool
 * comparison page in sync across the user's open browser tabs.
 */
export class CrossTabChannel<T> {
  private readonly channel: BroadcastChannel;

  constructor(name: string, onMessage: (data: T) => void) {
    this.channel = new BroadcastChannel(name);
    this.channel.onmessage = (event: MessageEvent<T>) => onMessage(event.data);
  }

  post(data: T): void {
    this.channel.postMessage(data);
  }
}
